var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "menu-with-submenu flex-between",
      class: { disabled: !_vm.subMenuAvailable }
    },
    [
      _c(
        "div",
        { staticClass: "menu-left" },
        [
          _c("fluent-icon", {
            staticClass: "menu-icon",
            attrs: { icon: _vm.option.icon, size: "14" }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "menu-label" }, [
            _vm._v(_vm._s(_vm.option.label))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("fluent-icon", { attrs: { icon: "chevron-right", size: "12" } }),
      _vm._v(" "),
      _vm.subMenuAvailable
        ? _c("div", { staticClass: "submenu" }, [_vm._t("default")], 2)
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }